module.exports = __webpack_public_path__ + "img/cute pupies-14.099d5ca7.png";